module.exports = __webpack_public_path__ + "static/waiter-app-1-51fccb93ee6665087eedc966e8161887.png";